import React, { useState, useEffect } from 'react';
import {
  Snackbar,
  Alert,
  Popover,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import NotificationBell from './NotificationBell';
import NotificationPanel from './NotificationPanel';

const Notifications = ({ disableTooltip = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [toastOpen, setToastOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


  const [toast, setToast] = useState({
    severity: 'info',
    message: '',
    title: '',
  });

  // Обработка всплывающих уведомлений
  useEffect(() => {
    const handleShowNotification = (event) => {
      const notification = event.detail;

      setToast({
        severity: notification.type || 'info',
        title: notification.title,
        message: notification.message,
      });

      setToastOpen(true);
    };

    window.addEventListener('showNotification', handleShowNotification);

    return () => {
      window.removeEventListener('showNotification', handleShowNotification);
    };
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToastClose = () => {
    setToastOpen(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'notification-popover' : undefined;

  return (
    <>
      <NotificationBell onClick={handleClick} disableTooltip={disableTooltip} />
      
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: isMobile ? 'bottom' : 'top',
          horizontal: isMobile ? 'right' : 'left',
        }}
        transformOrigin={{
          vertical: isMobile ? 'top' : 'bottom',
          horizontal: isMobile ? 'right' : 'left',
        }}
        PaperProps={{
          sx: {
            bgcolor: 'background.paper',
            borderRadius: '16px',
          },
        }}
      >
        <NotificationPanel onClose={handleClose} />
      </Popover>

      <Snackbar
        open={toastOpen}
        autoHideDuration={6000}
        onClose={handleToastClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleToastClose}
          severity={toast.severity}
          sx={{ width: '100%' }}
        >
          <strong>{toast.title}</strong> - {toast.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Notifications;

